import React from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import PageNotFound from '../page-not-found';
import routes from '../../../routes';
import './main.css';

const Main = () => {
  const location = useLocation();

  return (
    <main>
      <SwitchTransition mode="out-in">
        <CSSTransition
          key={location.pathname}
          classNames="fade"
          timeout={300}
          unmountOnExit
        >
          <div className="route-wrapper">
            <Routes location={location}>
              {routes.map((routeData, i) => {
                const RouteComponent = routeData.component;
                return (
                  <Route
                    key={`route-${i}`}
                    path={routeData.path}
                    element={<RouteComponent />}
                  />
                );
              })}
              <Route path="*" element={<PageNotFound />} />
            </Routes>
          </div>
        </CSSTransition>
      </SwitchTransition>
    </main>
  );
};

export default Main;
